import ContentSchema from './ContentSchema'

class JsonLD extends ContentSchema {
    static isMatch() {
        let jsonld
        try {
            jsonld = JSON.parse(document.querySelector('script[type="application/ld+json"]'))
        } catch (error) {
            jsonld = null
        }
        return !!jsonld
    }

    static findContent(overrides) {
        const jsonld = JSON.parse(document.querySelector('script[type="application/ld+json"]'))

        const url = overrides?.url || JsonLD.getUrl()
        const origin = overrides?.origin || JsonLD.getOrigin()
        // eslint-disable-next-line camelcase
        const resource_ref = overrides?.resource_ref || JsonLD.getResourceRef()

        const content = {
            origin,
            // eslint-disable-next-line camelcase
            resource_ref,
            url,
        }

        if (overrides?.author) {
            content.author = overrides.author
        } else if ((jsonld.author || {}).name) {
            content.author = (jsonld.author || {}).name
        } else {
            content.author = JsonLD.getAuthor()
        }

        if (overrides?.title) {
            content.title = overrides.title
        } else if (jsonld.headline) {
            content.title = jsonld.headline
        } else {
            content.title = JsonLD.getTitle()
        }

        return JsonLD.content(content)
    }
}

export default JsonLD
